// extracted by mini-css-extract-plugin
export default {"separator":"separator_separator__i4kpJ","square":"separator_square__g85hL"};